const actions = {
  FETCH_GROUPS: 'FETCH_GROUPS',
  FETCH_GROUPS_SUCCESS: 'FETCH_GROUPS_SUCCESS',
  FETCH_GROUPS_ERROR: 'FETCH_GROUPS_ERROR',
  GROUP_SET: 'group/SET_VALUE',
  GROUP_ADD: 'group/ADD_VALUE',
  GROUP_DEL: 'group/DEL_VALUE',
  GROUP_SUCCESS: 'group/SUCCESS',
  GROUP_ERROR: 'group/ERROR',
}

export default actions
